// Basic GDPR/cookie consent utilities

export const COOKIE_CATEGORIES = {
  ESSENTIAL: 'essential',
  ANALYTICS: 'analytics',
  FUNCTIONAL: 'functional',
  MARKETING: 'marketing',
}

const PREFERENCES_KEY = 'storyworld_cookie_preferences'

export const getCookiePreferences = () => {
  try {
    const raw = localStorage.getItem(PREFERENCES_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

export const saveCookiePreferences = (prefs) => {
  localStorage.setItem(PREFERENCES_KEY, JSON.stringify(prefs))
  window.dispatchEvent(
    new CustomEvent('cookieConsentUpdated', {
      detail: { preferences: prefs },
    })
  )
}

export const isCookieCategoryAllowed = (category) => {
  const prefs = getCookiePreferences()
  if (!prefs) return false
  if (category === COOKIE_CATEGORIES.ESSENTIAL) return true
  return !!prefs[category]
}

export const setFunctionalCookie = (name, value, days = 365) => {
  if (!isCookieCategoryAllowed(COOKIE_CATEGORIES.FUNCTIONAL)) return
  const expires = new Date()
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;secure;samesite=strict`
}

export const getFunctionalCookie = (name) => {
  if (!isCookieCategoryAllowed(COOKIE_CATEGORIES.FUNCTIONAL)) return null
  const nameEQ = name + '='
  const parts = document.cookie.split(';')
  for (let i = 0; i < parts.length; i++) {
    let c = parts[i]
    while (c.charAt(0) === ' ') c = c.substring(1)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length)
  }
  return null
}

export default {
  COOKIE_CATEGORIES,
  getCookiePreferences,
  saveCookiePreferences,
  isCookieCategoryAllowed,
  setFunctionalCookie,
  getFunctionalCookie,
}


